import React from "react";
import {CancellationReason} from "../../../declarations";
import {Collapse, Colors, Container, FormControlLabel, Radio, RadioGroup, Text} from "../../../../ui";
import {Dialog, TextField} from "../../../bounce-ui";
import {CANCELLATION_REASON_OPTIONS} from "./components";

interface ICancelPaymentPlanDialogContent {
  selectedReason: CancellationReason | undefined;
  onSelectReason: (reason: CancellationReason) => void;
  freeText: string;
  onChangeFreeText: (value: string) => void;
  cancelPaymentPlanHandler: () => void;
  handleLeavePlan: () => void;
}

export const CancelPaymentPlanDialogContent = ({
  selectedReason,
  onSelectReason,
  freeText,
  onChangeFreeText,
  cancelPaymentPlanHandler,
  handleLeavePlan,
}: ICancelPaymentPlanDialogContent) => {
  return (
    <Dialog
      title={"Tell us why you'd like to cancel"}
      buttonText={"Confirm and cancel"}
      onClick={cancelPaymentPlanHandler}
      secondaryButtonText={"Keep my plan"}
      onClickSecondary={handleLeavePlan}
      isError
      disabled={!selectedReason}
    >
      <Container fullWidth sx={{gap: "16px", alignItems: "start", overflow: "auto"}}>
        <Text>This helps us offer better options.</Text>
        <RadioGroup
          value={selectedReason ?? ""}
          onChange={(event) => onSelectReason(event.target.value as CancellationReason)}
          sx={{width: "100%", gap: "8px"}}
        >
          {CANCELLATION_REASON_OPTIONS.map((option) => (
            <FormControlLabel
              key={option.id}
              value={option.id}
              control={<Radio size={"medium"} />}
              label={
                <Text variant={"inter600"} size={14}>
                  {option.label}
                </Text>
              }
              sx={{
                margin: 0,
                borderRadius: "8px",
                border: `1px solid ${Colors.grey._300}`,
                padding: "8px 12px",
              }}
            />
          ))}
        </RadioGroup>
        <Collapse in={selectedReason === "other"} sx={{width: "100%"}} unmountOnExit>
          <TextField
            fullWidth
            multiline
            rows={3}
            placeholder={"Tell us more (optional)"}
            value={freeText}
            onChange={(event) => onChangeFreeText(event.target.value)}
            inputProps={{maxLength: 1024}}
          />
        </Collapse>
      </Container>
    </Dialog>
  );
};
